<template>
  <div class="col-lg-12 control-section">
    <ejs-grid
      :dataSource="fmData"
      ref="grid"
      :allowSelection="true"
      :rowSelected="setChildProps"
      :rowDeselected="setChildProps"
    >
      <e-columns>
        <e-column type="checkbox" width="50" textAlign="center"></e-column>
        <e-column field="text" isPrimaryKey="true" :headerText='fmOrAm===0 ? $t("System.resource") : $t("System.alarmType")' width="120" textAlign="left"></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
export default {
  name: "OprSetDialog",
  props: {
    fmOrAm: Number
  },
  data() {
    return {
      fmData: [],
      amData: [
        { text: `${this.$t('System.curAlarmData')}`, value: 1 },
        { text: `${this.$t('System.hisAlarmData')}`, value: 2 },
        { text: `${this.$t('System.busData')}`, value: 3 }
      ]
    };
  },
  methods: {
    setChildProps() {
      let index = this.$refs.grid.ej2Instances.getSelectedRowIndexes();
      let selectedData = [];
      let id;
      if (this.fmOrAm === 0) {
        index.forEach(e => {
          selectedData.push(this.fmData[e].value);
        });
        id = 2;
      } else {
        index.forEach(e => {
          selectedData.push(this.amData[e].value);
        });
        id = 3;
      }
      let param = { moduleId: id, setIdLst: selectedData };
      this.$emit("childProps", param);
    },
    setBasicTitle() {
      if (this.fmOrAm === 0) {
        this.axios.get("/lte/ems/sysmanager/productInfo/getAmNeList").then(res => {
          this.fmData = res.data;
          this.$refs.grid.ej2Instances.dataSource = this.fmData;
        });
      } else {
        this.$refs.grid.ej2Instances.dataSource = this.amData;
      }
      this.setChildProps();
    }
  },
  mounted() {
    this.setBasicTitle();
  },
  watch: {
    fmOrAm() {
      this.setBasicTitle();
    }
  }
};
</script>
